import styles from "./styles.module.css";
import { useParams, useHistory } from "react-router-dom";
import { useState, useContext } from "react";
import { AppDisbatch } from "../../../contexts/app";
import Modal from "../../../modal";

export default function DangerZone({ deleteBlock, block, editorDisbatch }) {
  return (
    <div className={styles.dangerZone}>
      <div className={styles.propTitle}>Danger Zone</div>
      {block.component !== "Page" && (
        <button onClick={deleteBlock} id={styles.deleteButton}>
          Delete
        </button>
      )}
      {block.component === "Page" && block.editable && (
        <DeletePage editorDisbatch={editorDisbatch} block={block} />
      )}
    </div>
  );
}

const DeletePage = ({ block, editor, editorDisbatch }) => {
  const { appId, type, pageId } = useParams();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const disbatch = useContext(AppDisbatch);

  const handleDelete = () => {
    disbatch({ type: "deletePage", page: pageId });
    history.push(`/${appId}/canvas/${type}/index`);
    setOpen(false);
    editorDisbatch({
      type: "set",
      value: null,
    });
  };

  return (
    <>
      {" "}
      <button onClick={() => setOpen(true)} id={styles.deleteButton}>
        Delete Page
      </button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div
          style={{
            width: 300,
            backgroundColor: "white",
            borderRadius: 8,
            padding: 15,
            fontFamily: "var(--font)",
          }}
        >
          <div style={{ fontSize: 18, color: "#666" }}>
            Are you sure you want to delete {block.name}?
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <button onClick={handleDelete} id={styles.deleteButton}>
              Delete
            </button>
            <button className={styles.cancelButton}>Cancel</button>
          </div>
        </div>
      </Modal>
    </>
  );
};
